import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04a37bef&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a37bef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a37bef')) {
      api.createRecord('04a37bef', component.options)
    } else {
      api.reload('04a37bef', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=04a37bef&scoped=true", function () {
      api.rerender('04a37bef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerSelectCmp/index.vue"
export default component.exports